import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Background, { BackgroundType } from '@/Layouts/containers/Background';
import Header from '@/Components/Header';
import Footer from '@/Components/Footer';
import AppLink from '@/Components/AppLink';
import useIsNonDefaultPage from '@/Hooks/useIsNonDefaultPage';
import styles from './styles.module.scss';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};
const PageWrapper: React.FC = ({ children }) => {
  const isNonDefaultPage = useIsNonDefaultPage();

  return (
    <>
      {!isNonDefaultPage && <Header />}
      {!isNonDefaultPage && <AppLink />}
      <div className={styles.contentWrapper}>{children}</div>
      {!isNonDefaultPage && <Footer />}
    </>
  );
};
const Default: React.FC<InferProps<typeof propTypes>> = ({ children }) => {
  // const { selectedProfile } = useCustomerProfile();
  // const { isAuthenticated } = useAuth();

  return (
    <Background type={BackgroundType.Default}>
      <PageWrapper>{children}</PageWrapper>
    </Background>
  );
};

Default.propTypes = propTypes;
Default.defaultProps = defaultProps;

export default Default;
